// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var Select = require("@mui/material/Select").default;
var MenuItem = require("@mui/material/MenuItem").default;
var Add = require("@mui/icons-material/Add").default;
var TextField = require("@mui/material/TextField").default;
var IconButton = require("@mui/material/IconButton").default;
var InputLabel = require("@mui/material/InputLabel").default;
var FormControl = require("@mui/material/FormControl").default;
var Delete = require("@mui/icons-material/Delete").default;

function MM_cmp_type_settings(props) {
  var onRestoreDefaults = props.onRestoreDefaults;
  var onDelete = props.onDelete;
  var onPrefixChange = props.onPrefixChange;
  var onColorChange = props.onColorChange;
  var onTypeChange = props.onTypeChange;
  var onAdd = props.onAdd;
  var availableColors = props.availableColors;
  var rndColorSelect = function (selectedColor, onNewColorSelected) {
    return React.createElement(FormControl, {
                size: "small",
                children: Caml_option.some(null)
              }, React.createElement(InputLabel, {
                    id: "label-for-color-select",
                    children: "Color"
                  }), React.createElement(Select, {
                    labelId: "label-for-color-select",
                    label: "Color",
                    value: selectedColor,
                    onChange: (function (param) {
                        return Expln_React_common.evt2str(onNewColorSelected, param);
                      }),
                    children: Caml_option.some(availableColors.map(function (color) {
                              return JsxPPXReactSupport.createElementWithKey(color, MenuItem, {
                                          value: color,
                                          children: Caml_option.some(React.createElement("div", {
                                                    style: {
                                                      backgroundColor: color,
                                                      height: "20px",
                                                      width: "50px"
                                                    }
                                                  }))
                                        });
                            }))
                  }));
  };
  var rndTypeSetting = function (ts) {
    var msg = ts.err;
    return JsxPPXReactSupport.createElementVariadicWithKey(ts.id, Expln_React_Column.make, {
                children: Caml_option.some(null)
              }, [
                React.createElement(Expln_React_Row.make, {
                      children: Caml_option.some(null)
                    }, React.createElement(TextField, {
                          value: ts.typ,
                          label: "Type",
                          size: "small",
                          style: {
                            width: "100px"
                          },
                          onChange: (function (param) {
                              return Expln_React_common.evt2str((function (__x) {
                                            Curry._2(onTypeChange, ts.id, __x);
                                          }), param);
                            })
                        }), rndColorSelect(ts.color, (function (__x) {
                            Curry._2(onColorChange, ts.id, __x);
                          })), React.createElement(TextField, {
                          value: ts.prefix,
                          label: "Prefix",
                          size: "small",
                          style: {
                            width: "100px"
                          },
                          onChange: (function (param) {
                              return Expln_React_common.evt2str((function (__x) {
                                            Curry._2(onPrefixChange, ts.id, __x);
                                          }), param);
                            })
                        }), JsxPPXReactSupport.createElementWithKey("delete-button", IconButton, {
                          onClick: (function (param) {
                              Curry._1(onDelete, ts.id);
                            }),
                          children: Caml_option.some(React.createElement(Delete, {}))
                        })),
                msg !== undefined ? React.createElement("pre", {
                        style: {
                          color: "red"
                        }
                      }, msg) : null
              ]);
  };
  return React.createElement(Expln_React_Column.make, {
              style: {
                marginTop: "5px"
              },
              children: Caml_option.some(null)
            }, props.typeSettings.map(rndTypeSetting), React.createElement(Expln_React_Row.make, {
                  alignItems: "baseline",
                  children: Caml_option.some(null)
                }, JsxPPXReactSupport.createElementWithKey("add-button", IconButton, {
                      onClick: (function (param) {
                          Curry._1(onAdd, undefined);
                        }),
                      children: Caml_option.some(React.createElement(Add, {}))
                    }), React.createElement("span", {
                      style: {
                        color: "grey",
                        cursor: "pointer",
                        fontSize: "0.7em"
                      },
                      onClick: (function (param) {
                          Curry._1(onRestoreDefaults, undefined);
                        })
                    }, "Restore default type settings")));
}

var make = MM_cmp_type_settings;

exports.make = make;
/* react Not a pure module */
